export const SET_GLOBAL_CONFIGS = 'SET_GLOBAL_CONFIGS';
export const SET_GLOBAL_CSS_CDN = 'SET_GLOBAL_CSS_CDN';
export const SET_GLOBAL_ASSETS = 'SET_GLOBAL_ASSETS'
